module.exports = __webpack_public_path__ + "img/intro_en.5814269a.png";